import DropdownPro from 'epn-ui/umd/dist/components/DropdownPro';
import type { DropdownItems } from 'epn-ui/umd/dist/components/DropdownPro/types';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './DropdownNew.module.scss';

interface IDropdownNew {
    label: string | React.ReactNode;
    items: DropdownItems;
    classname: string;
}

const DropdownNew: React.FC<IDropdownNew> = ({ label, items, classname = '' }) => {
    return (
        <DropdownPro className={classname} menu={{ items }}>
            <span className="flex items-center cursor-pointer">
                {label}
                <FontAwesomeIcon className={styles.dropdownArrow} icon={faChevronDown} />
            </span>
        </DropdownPro>
    );
};

export default DropdownNew;
